<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Add New Expense</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="addExpenseForm" v-model="valid" lazy-validation>
        <v-layout column>
        <v-flex xs12 class="mb-4">
            <v-autocomplete
              label="Company"
              v-model="newItem.company_id"
              :items="companyTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
            >
            </v-autocomplete>
          </v-flex>

          <v-flex xs12>
            <v-menu
              v-model="paymentDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="newItem.payment_date"
                  label="Date *"
                  readonly
                  outline
                  required
                  :rules="requiredRules"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newItem.payment_date"
                @input="paymentDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex sm12 class="pb-4">
            <v-autocomplete
              label="Expense Head *"
              v-model="newItem.account_head_id"
              :items="accountHeadsTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>
          
          <v-flex xs12>
            <v-text-field
              outline
              label="Amount *"
              type="number"
              required
              v-model="newItem.amount"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>

          <v-flex sm12>
            <v-radio-group required v-model="newItem.method" row label="Payment Method: ">
              <v-radio
                :label="item.charAt(0).toUpperCase() + item.slice(1)"
                :value="item"
                v-for="(item, index) in PAYMENT_METHODS"
                :key="index"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs12 v-if="newItem.method == 'cheque'">
            <v-menu
              v-model="checkDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="newItem.check_date"
                  label="Check Issued Date"
                  readonly
                  outline
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newItem.check_date"
                @input="checkDateMenu = false"
              ></v-date-picker>
            </v-menu>

            <v-text-field
              outline
              label="Check Number"
              v-model="newItem.check_number"
            ></v-text-field>
            <v-text-field
              outline
              label="Bank Name"
              v-model="newItem.check_bank_name"
            ></v-text-field>
            <v-text-field
              outline
              label="Branch Name"
              v-model="newItem.check_bank_branch"
            ></v-text-field>
          </v-flex>
          <v-textarea v-model="newItem.notes" outline label="Notes"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="newItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Add</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { PAYMENT_METHODS } from "../../mdsir/const";
import { getTV, removeEmptyProps } from "../../mdsir/MdsirUtils";

const NEW_ITEM_DEFAULT = {
  company_id: "",
  payment_date: new Date().toISOString().substr(0, 10),
  amount: "",
  method: "cash",
  check_date: "",
  check_number: "",
  check_bank_name: "",
  check_bank_branch: "",
  notes: "",
  account_head_id: "",
};
export default {
  props:["accountHeadsTV", "companyTV"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: NEW_ITEM_DEFAULT,
      paymentDateMenu: false,
      checkDateMenu: false,
    };
  },
  computed:{
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addExpenseForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addExpenseForm.reset();
    },
    resetValidation() {
      this.$refs.addExpenseForm.resetValidation();
    },
    clearForm() {
      this.newItem = {
        payment_date: new Date().toISOString().substr(0, 10),
        amount: "",
        method: "cash",
        check_date: "",
        check_number: "",
        check_bank_name: "",
        check_bank_branch: "",
        notes: "",
        account_head_id: "",
      };
    },
    newItemDo() {
      if (this.$refs.addExpenseForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/expense", removeEmptyProps(this.newItem, ["check_date", "account_head_id"])).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
  },
  mounted() {},
  created() {
    this.PAYMENT_METHODS = PAYMENT_METHODS;
  },
};
</script>
